<template>
    <header>
        <nav class="navbar navbar-expand-md fixed-top ">
            <a class="navbar-brand" href="/"></a>
            <button class="navbar-toggler showmenu hamburger hamburger--3dx" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <div class="hamburger-box">
                <div class="hamburger-inner"></div>
            </div>
            </button>
            <div class="collapse navbar-collapse " id="navbarCollapse">
            <ul class="navbar-nav ">
                
                
                <li class="nav-item dropdown"   data-aos="fade-up" data-aos-duration="1000">
                <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown" aria-expanded="false" :class="{'nav-link-en':lang=='en'}">{{ $t('HEADER.ABOUT') }}</a>
                <div class="dropdown-menu" aria-labelledby="dropdown01">
                    <a class="dropdown-item" href="/about">{{ $t('HEADER.MISSION') }}</a>
                    <a class="dropdown-item" href="/ourmember">{{ $t('HEADER.OURMEMBERS') }}</a>
                </div>
                </li>
                <li class="nav-item  dropdown" data-aos="fade-up" data-aos-duration="1150">
                <a class="nav-link dropdown-toggle" href="#"  id="dropdown02" data-toggle="dropdown" aria-expanded="false" :class="{'nav-link-en':lang=='en'}">{{ $t('HEADER.NEWSCENTER') }}</a>
                <div class="dropdown-menu" aria-labelledby="dropdown01">
                    <a class="dropdown-item" href="/news">{{ $t('HEADER.LATESTNEWS') }}</a>
                    <a class="dropdown-item" href="/media">{{ $t('HEADER.MEDIA') }}</a>
                </div>
                </li>
                <li class="nav-item dropdown" data-aos="fade-up" data-aos-duration="1300">
                <a class="nav-link dropdown-toggle" href="#"  id="dropdown02" data-toggle="dropdown" aria-expanded="false" :class="{'nav-link-en':lang=='en'}">{{ $t('HEADER.OBSERVATION') }}</a>
                <div class="dropdown-menu" aria-labelledby="dropdown01">
                    <a class="dropdown-item" href="/world">{{ $t('HEADER.WORLDNEWS') }}</a>
                    <a class="dropdown-item" href="/view">{{ $t('HEADER.VIEWS') }}</a>
                </div>
                </li>
                <li class="nav-item" data-aos="fade-up" data-aos-duration="1450">
                <a class="nav-link" href="/research" :class="{'nav-link-en':lang=='en'}">{{ $t('HEADER.PROJECTS') }}</a>
                </li>
                <li class="nav-item" data-aos="fade-up" data-aos-duration="1600">
                <a class="nav-link" href="/cooperate" :class="{'nav-link-en':lang=='en'}">{{ $t('HEADER.COLLABORATION') }}</a>
                </li>
                <li class="nav-item"  data-aos="fade-up" data-aos-duration="1750">
                <a class="nav-link" href="/activity" :class="{'nav-link-en':lang=='en'}">{{ $t('HEADER.ACTIVITIES') }}</a>
                </li>
                <li class="nav-item"  data-aos="fade-up" data-aos-duration="1800">
                    <a class="nav-link" href="/contact" :class="{'nav-link-en':lang=='en'}">{{ $t('HEADER.CONTACTUS') }}</a>
                </li>
            </ul>
            <!--
            <form class="form-inline mt-md-0 ">
                <button class="btn btn-outline-success my-2 my-sm-0" type="button" data-aos="fade-up" data-aos-duration="1900" v-if="lang=='zh'" @click="setLang('en')">EN</button>
                <button class="btn btn-outline-success my-2 my-sm-0" type="button" data-aos="fade-up" data-aos-duration="1900" v-if="lang=='en'" @click="setLang('zh')">TW</button>
            </form>
            -->
            </div>
        </nav>
        </header>
</template>

<script>
export default {
    name: 'Header',
    data () {
        return {
            name:'',
            lang:''
        }
    },
    mounted() {
        this.lang = localStorage.getItem('language') || 'zh';
    },
    methods: {
        setLang(val){
            localStorage.setItem('language', val)
            return history.go(0)
        }
    }
}
</script>
<style scoped>
.nav-link-en{
    padding-left:16px !important;
    padding-right:16px !important;
    font-size:14px;
}
</style>


// WEBPACK FOOTER //
// src/components/index/shared/Header.vue